import { Link } from "react-router";
import FAQItem from "./FAQItem";

import { faqs } from "../../data/faqData";

import {
  FAQWrapper,
  FAQContainer,
  FAQHeader,
  FAQAccent,
  FAQTitle,
  ViewAllButton,
} from "./FAQ.styles";
import { useState } from "react";
const FAQSection = () => {
 // First FAQ is open by default
  const [openIndex, setOpenIndex] = useState(null);
  return (
    <FAQWrapper>
      <FAQContainer>
        <FAQHeader>
          <FAQAccent />
          <FAQTitle>Frequently Asked Questions (FAQs)</FAQTitle>
          <ViewAllButton
            as={Link}
            to="/frequently-asked-questions"
          >
            View All FAQs
          </ViewAllButton>
        </FAQHeader>

        {faqs.map((faq, index) => (
  <FAQItem
    key={faq.question}
    question={faq.question}
    answer={faq.answer}
    open={openIndex === index}
    onToggle={() =>
      setOpenIndex(openIndex === index ? null : index)
    }
  />
))}
      </FAQContainer>
    </FAQWrapper>
  );
};

export default FAQSection;
